import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { GridRowModes, GridRowModesModel, GridRowsProp, GridToolbarContainer } from '@mui/x-data-grid'
import { AddOutlined } from "@mui/icons-material"
import Text from "../../../assets/components/Text"
import BasicButton from "../../../assets/components/BasicButton"
import { useState } from "react"
import { Song } from "../../../utils/types"

import { useContext } from "react"
import { PolyglotContext } from "../../../polyglot/polyGlotContext"

interface DialogProps {
    open: boolean
    heading: string
    text: string
}

interface SongsAndSoundsToolbarProps {
    setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
    setRowModesModel: (
        newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
    ) => void;
    rows: Song[];
}

const SongsAndSoundsToolbar = (props: SongsAndSoundsToolbarProps) => {
    const { polyglot } = useContext(PolyglotContext);

    const { setRows, setRowModesModel, rows } = props;
    const [dialog, setDialog] = useState<DialogProps>({ open: false, heading: "", text: "" });

    const createNewSong = () => {
        // Generate new id for song
        //const id = generateNewSongId()  // Use this id generation function if you want to get a unique "non-readable" id
        const id = rows.length + 1

        // Abort if no id could be generated
        if (!id) {
            openDialog(polyglot.t("admin.songsAndSoundsToolbar.failedAction"), polyglot.t("admin.songsAndSoundsToolbar.failedPostCreation"))
            return
        }

        // Update rows visually and start edit on the new row
        setRows((oldRows) => [...oldRows, { id, type: "music", isNew: true }]);
        setRowModesModel((oldModel) => ({
            ...oldModel,
            [id]: { mode: GridRowModes.Edit, fieldToFocus: 'id' },
        }));
    };

    const openDialog = (heading: string, text: string) => {
        setDialog({
            open: true,
            heading: heading,
            text: text
        })
    };

    const closeDialog = () => {
        setDialog({ ...dialog, open: false });
    };

    return (
        <GridToolbarContainer>
            <BasicButton title={polyglot.t("admin.songsAndSoundsToolbar.addSongBtn")} icon={AddOutlined} onClick={createNewSong} />
            <Dialog
                open={dialog.open}
                onClose={closeDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <Text size="heading" bold>
                        {dialog.heading}
                    </Text>
                </DialogTitle>
                <DialogContent>
                    <Text>
                        {dialog.text}
                    </Text>
                </DialogContent>
                <DialogActions>
                    <BasicButton title={polyglot.t("admin.songsAndSoundsToolbar.closeDialogBtn")} onClick={closeDialog} />
                </DialogActions>
            </Dialog>
        </GridToolbarContainer>
    );
}

export default SongsAndSoundsToolbar